import React from 'react'
import { useSelector } from 'react-redux'
import { CircularProgress, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'

import { selectCardView } from 'store/selectors/pageSettings'
import { CardViewEnum } from 'store/reducers/pageSettings'

import FunderCard from 'components/FunderCard'
import { useTranslation } from 'react-i18next'
import { selectPipeline } from 'store/selectors/pipeline'
import SearchBanner from './components/SearchBanner'
import { selectResultCount } from 'store/selectors/search'
import { selectHasExecutePermissions } from 'store/selectors/user'

const SearchResults = ({ loading, results }) => {
  const { i18n } = useTranslation()
  const t = i18n.getResourceBundle(i18n.language)

  const cardView = useSelector(selectCardView)
  const { results: pipelineData } = useSelector(selectPipeline)
  const resultCount = useSelector(selectResultCount)
  const hasExecutePermissions = useSelector(selectHasExecutePermissions)

  const buildFunderCard = (funder, index) => (
    <FunderCard
      data={funder}
      key={funder.id}
      index={index}
      opportunity={pipelineData.find(opportunity => opportunity.funder.id === funder.id)}
    />
  )

  return (
    <>
      {loading ? (
        <div className="refresh-container">
          <CircularProgress size={60} thickness={5} color="#4c9eff" />
        </div>
      ) : null}
      {cardView === CardViewEnum.COLLAPSED ? (
        <Table padding="none" className="Material-cards__collapsed">
          <TableHead>
            <TableRow>
              <TableCell>{t.cards.funderName}</TableCell>
              <TableCell>{t.cards.typicalGift}</TableCell>
              <TableCell>{t.cards.upcomingDeadline}</TableCell>
              <TableCell>{t.cards.estimatedCapacity}</TableCell>
              {hasExecutePermissions && (
                <TableCell className="pipeline-stage">{t.cards.pipelineStage}</TableCell>
              )}
              <TableCell>{/* Action */}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{results.map(buildFunderCard)}</TableBody>
        </Table>
      ) : (
        <div className="tw-w-full">
          <div className={'Search_tiles'}>
            <div className={'Search_tiles--content'}>{results.map(buildFunderCard)}</div>
          </div>
        </div>
      )}
      {resultCount !== null && <SearchBanner resultCount={resultCount} />}
    </>
  )
}

export default SearchResults
